import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import czData from './data/partners_cz.json';
import skData from './data/partners_sk.json';
import huData from './data/partners_hu.json';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { Language } from '@/constants/currencyConfig';
export type Partner = {
  name: string;
  cin: string;
};
export type PartnersQueryResult = {
  data: Partner[] | undefined;
  isLoading: boolean;
  isError: boolean;
};
export function usePartnersQuery(language) {
  const $ = _c(11);
  let t0;
  if ($[0] !== language) {
    t0 = QUERY_KEYS.ourPartners(language);
    $[0] = language;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== language) {
    t1 = async () => new Promise(resolve => {
      bb3: switch (language) {
        case "sk":
          {
            resolve(skData);
            break bb3;
          }
        case "hu":
          {
            resolve(huData);
            break bb3;
          }
        default:
          {
            resolve(czData);
          }
      }
    });
    $[2] = language;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data,
    isLoading,
    isError
  } = useQuery(t2);
  let t3;
  if ($[7] !== data || $[8] !== isError || $[9] !== isLoading) {
    t3 = {
      data,
      isLoading,
      isError
    };
    $[7] = data;
    $[8] = isError;
    $[9] = isLoading;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}